"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinneTyp = void 0;
var FuehrungsrinneTyp;
(function (FuehrungsrinneTyp) {
    FuehrungsrinneTyp["SuperAlu"] = "SuperAlu";
    FuehrungsrinneTyp["Stahl"] = "Stahl";
})(FuehrungsrinneTyp = exports.FuehrungsrinneTyp || (exports.FuehrungsrinneTyp = {}));
//# sourceMappingURL=fuehrungsrinne-typ.js.map